import { getCurrentRoute, getCurrentRouteGroup } from '@/services/route';

import { getCompanySubdomain } from '../helpers';
import {
  getLocalStorageOversightToken,
  getLocalStorageToken,
} from '../helpers/localStorage';
import { EventGroup } from './enumerations';

const API_PORT = process.env.REACT_APP_API_PORT || '';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const STRING_REPLACE = '{{subdomain}}';

export const handleUrl = (): string => {
  if (API_BASE_URL) {
    return API_BASE_URL;
  }

  const companySubdomain = getCompanySubdomain();
  const dynamicUrl = `https://${STRING_REPLACE}.com.br:${API_PORT}`;

  if (companySubdomain) {
    return dynamicUrl.replace(STRING_REPLACE, companySubdomain);
  }

  return dynamicUrl.replace(STRING_REPLACE, 'realprice-st.protoai');
};

const EVENT_TYPE_SEPARATOR = ':';

const normalizeRoute = (route?: string): string =>
  route?.trim() ? route : 'unknown';

// `Event-Type` is `<group>:<route>`. The group is what the session timeline
// collapses into a single accordion, so it defaults to the normalized route
// pattern (ids stripped) and is only overridden for calls that do not belong to
// the screen the user is looking at.
const buildEventType = (group?: EventGroup): string => {
  const eventGroup = group ?? normalizeRoute(getCurrentRouteGroup());

  return `${eventGroup}${EVENT_TYPE_SEPARATOR}${normalizeRoute(
    getCurrentRoute()
  )}`;
};

const buildBaseHeaders = (
  token: string | null,
  group?: EventGroup
): Headers => {
  const myHeaders = new Headers();

  if (token) {
    myHeaders.append('Authorization', `Bearer ${token}`);
  }

  myHeaders.append('Event-Type', buildEventType(group));

  return myHeaders;
};

// Datetimes come back as UTC ISO with `Z` (docs/guideline/datetime.md).
// Oversight is a separate service outside this contract, so it never gets it.
export const datetimeFormat = 'iso-utc';
export const datetimeFormatHeader = 'X-Datetime-Format';

const buildApiHeaders = (group?: EventGroup): Headers => {
  const myHeaders = buildBaseHeaders(getLocalStorageToken(), group);
  myHeaders.append(datetimeFormatHeader, datetimeFormat);

  return myHeaders;
};

export const myHeadersWithTokenContentType = (group?: EventGroup): Headers => {
  const myHeaders = buildApiHeaders(group);
  myHeaders.append('Content-Type', 'application/json');

  return myHeaders;
};

export const myHeadersWithToken = (group?: EventGroup): Headers =>
  buildApiHeaders(group);

export const myHeadersWithTokenOversight = (group?: EventGroup): Headers =>
  buildBaseHeaders(getLocalStorageOversightToken(), group);
